export default function UserGradientCircle({ className }: { className?: string }) {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="20" cy="20" r="20" fill="url(#paint0_linear_459_18509)" />
      <defs>
        <linearGradient
          id="paint0_linear_459_18509"
          x1="48.5"
          y1="17.5"
          x2="-14"
          y2="45"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.114583" stopColor="#191363" />
          <stop offset="0.411458" stopColor="#303E8B" />
          <stop offset="0.6875" stopColor="#2E5981" />
          <stop offset="1" stopColor="#161B8E" />
        </linearGradient>
      </defs>
    </svg>
  )
}
